import dynamic from 'next/dynamic'
import { createContext, useCallback, useContext, useMemo, useState } from 'react'
import { useStore } from '../store'

const Search = dynamic(() => import('@bluheadless/ui/src/organisms/search/search'), { ssr: false })

const SearchContext = createContext()

const SearchProvider = ({ children }) => {
	const [open, setOpen] = useState(false)
	const [value, setValue] = useState(false)
	const { code: storeCode } = useStore()

	const onClose = useCallback(() => {
		setOpen(false)
	}, [])

	const onSubmit = useCallback(() => {
		setOpen(false)
		onClose()
	}, [onClose])

	const contextValue = useMemo(() => ({ onSubmit, open, setOpen, setValue, value }), [onSubmit, open, value])

	return (
		<SearchContext.Provider value={contextValue}>
			{!!storeCode && <Search onClose={onClose} />}
			{children}
		</SearchContext.Provider>
	)
}

export default SearchProvider

export const useSearchContext = () => {
	const searchContextValue = useContext(SearchContext)

	if (!searchContextValue) {
		console.warn(`Search context value is missing. Verify that SearchProvider is a parent of the current component.`)
	}

	return searchContextValue
}
